import { Injectable, Injector } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';

@Injectable()
export class SegmentService {
	userService : any;

  constructor(public injector : Injector) {
    this.injectUserService();
  }

  injectUserService() {
    if(!this.userService) {
      this.userService = this.injector.get(UserService);
    }
  }

  checkToRunSegment() {
    let w = (<any>window);
    return environment.APP.SEGMENT_TRACKING && !w.mmap.isIntegratedMapsActive();
  }

  log(eventName, eventObject?) {
    let w = (<any>window);
    if(this.checkToRunSegment()) {
      try {
        this.injectUserService();
        eventObject = (eventObject)? eventObject : {};
        eventObject.loggedIn = this.userService.loggedIn;
        if(w.userData && w.userData.profileId) {
          this.trackEvent(eventName, eventObject);
        } else {
          this.userService.getLoggedInUser().subscribe((userData)=>{
            w.Events.publish('updateUserData', userData);
            this.trackEvent(eventName, eventObject);
          });
        }
      } catch (err) {
        console.log('Segment Error '+ err);
      }
    }
  }

  excludeInternalTraffic(user) {
    if(environment.name === 'production') {
      if(user && user.emailAddress.includes('@propertycapsule.com')) {
        this.ignore();
      }
    }
  }

  ignore() {
    this.checkToRunSegment() && (<any>window).analytics.identify({'$ignore': true});
  }

  trackEvent(eventName, eventObject) {
    let w = (<any>window);
    if(w.userData && w.userData.profileId) {
      eventObject.profileId = w.userData.profileId;
      if(w.userData.organizationId) {
        eventObject.organizationId = w.userData.organizationId;
      }
      if(w.userData.organizationName) {
        eventObject.organizationName = w.userData.organizationName;
      }
      if(w.userData.emailAddress) {
        eventObject.emailAddress = w.userData.emailAddress;
      }
    }
    w.analytics.track(eventName, eventObject);
  }

  timeout(milisec) {
     this.checkToRunSegment() && (<any>window).analytics.timeout(milisec);
  }

  identify() {
    this.checkToRunSegment() && (<any>window).analytics.identify(this.userService.loggedInUser.userId.toString(), {
      profileId: this.userService.loggedInUser.profileId,
      name: this.userService.loggedInUser.fullName,
      email: this.userService.loggedInUser.emailAddress,
      company: this.userService.loggedInUser.organizationName,
      role: (this.userService.loggedInUser.systemAdmin || this.userService.loggedInUser.organizationAdmin) ? 'admin' : 'user',
    });
  }

  group() {
    this.checkToRunSegment() && this.userService.loggedInUser.organizationId && (<any>window).analytics.group(this.userService.loggedInUser.organizationId.toString(), {
      name: this.userService.loggedInUser.organizationName,
    });
  }

  alias() {
    this.checkToRunSegment() && (<any>window).analytics.alias(this.userService.loggedInUser.userId.toString(), {
      profileId: this.userService.loggedInUser.profileId,
      name: this.userService.loggedInUser.fullName,
      email: this.userService.loggedInUser.emailAddress,
      company: this.userService.loggedInUser.organizationName,
      role: (this.userService.loggedInUser.systemAdmin || this.userService.loggedInUser.organizationAdmin) ? 'admin' : 'user',
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/segment.service.ts